import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useNotificacionesCorreo from '../hooks/useNotificacionesCorreo';
import 'bootstrap/dist/css/bootstrap.min.css';

const ORIGEN_ICONO = {
    GMAIL:   { icon: 'bi-google',    color: '#EA4335', label: 'Gmail' },
    OUTLOOK: { icon: 'bi-microsoft', color: '#0078D4', label: 'Outlook' },
};

const MailCampana = () => {
    const [popoverVisible, setPopoverVisible] = useState(false);
    const popoverRef = useRef(null);
    const navigate = useNavigate();

    const {
        emails, loading, noLeidosCount, hayNoLeidos,
        abrirEmail, descartar,
    } = useNotificacionesCorreo();

    const handleClickEmail = (e, item) => {
        e.stopPropagation();
        abrirEmail(item, { onNavegar: () => setPopoverVisible(false) });
    };

    const handleDescartar = (e, item) => {
        e.stopPropagation();
        descartar(item);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (popoverRef.current && !popoverRef.current.contains(e.target)) {
                setPopoverVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div
            className="position-relative d-flex align-items-center justify-content-center"
            ref={popoverRef}
            style={{ width: '100%', height: '100%' }}
        >
            {/* ✉️ BOTÓN */}
            <button
                className="btn position-relative p-0 border-0 d-flex align-items-center justify-content-center"
                onClick={() => setPopoverVisible(!popoverVisible)}
                title="Notificaciones de email"
                style={{ width: '100%', height: '100%' }}
            >
                <i
                    className={`bi bi-envelope-fill ${hayNoLeidos ? 'text-warning shake-bell' : 'text-light'}`}
                    style={{
                        fontSize: '36px',
                        transition: 'transform 0.25s ease, color 0.25s ease',
                    }}
                    onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.15)')}
                    onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
                />
                {hayNoLeidos && (
                    <span
                        className="position-absolute rounded-circle"
                        style={{ width: '14px', height: '14px', top: '16%', right: '12%', backgroundColor: '#ffc107' }}
                    />
                )}
                {noLeidosCount > 0 && (
                    <span
                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark"
                        style={{ fontSize: '0.9rem', minWidth: '28px', padding: '0.35rem 0.5rem' }}
                    >
                        {noLeidosCount > 99 ? '99+' : noLeidosCount}
                    </span>
                )}
            </button>

            {/* 📋 PANEL DE EMAILS */}
            {popoverVisible && (
                <div
                    className="popover fade show position-absolute end-0"
                    style={{
                        top: '100%',
                        marginTop: '10px',
                        width: '470px',
                        maxWidth: '90vw',
                        backgroundColor: '#fff',
                        border: '1px solid #dee2e6',
                        borderRadius: '0.6rem',
                        boxShadow: 'var(--shadow-sm)',
                        zIndex: 2000,
                    }}
                >
                    <div
                        className="popover-header fw-semibold d-flex justify-content-between align-items-center"
                        style={{
                            padding: '0.9rem 1rem',
                            fontSize: '1.05rem',
                            background: 'var(--primary)',
                            color: '#fff',
                            borderRadius: '0.6rem 0.6rem 0 0',
                        }}
                    >
                        <span>✉️ Correos externos</span>
                        <div className="d-flex gap-2 align-items-center">
                            <button
                                className="btn btn-sm btn-light py-0 px-2"
                                onClick={() => { setPopoverVisible(false); navigate('/correos'); }}
                                style={{ fontSize: '0.75rem', fontWeight: 600 }}
                                title="Ver todos los correos"
                            >
                                Ver todos
                            </button>
                            <button
                                className="btn btn-sm btn-light py-0 px-2"
                                onClick={() => setPopoverVisible(false)}
                                style={{ fontSize: '1rem' }}
                            >
                                ×
                            </button>
                        </div>
                    </div>

                    <div className="popover-body" style={{ maxHeight: '420px', overflowY: 'auto', padding: '0.9rem' }}>
                        {loading ? (
                            <div className="text-center text-muted py-2">Cargando...</div>
                        ) : emails.length === 0 ? (
                            <div className="text-center text-muted py-2">No hay correos recientes</div>
                        ) : (
                            emails.map(item => {
                                const leido  = item?.leido === true;
                                const origen = item?.origen || 'GMAIL';
                                const meta   = ORIGEN_ICONO[origen] || ORIGEN_ICONO.GMAIL;
                                return (
                                    <div
                                        key={item.id}
                                        className="mb-3 rounded position-relative"
                                        onClick={(e) => handleClickEmail(e, item)}
                                        style={{
                                            padding: '0.9rem 2.5rem 0.9rem 0.9rem',
                                            cursor: 'pointer',
                                            backgroundColor: leido ? '#f8f9fa' : '#fff9e6',
                                            borderLeft: leido ? '4px solid #d9d9d9' : '4px solid #ffc107',
                                            opacity: leido ? 0.7 : 1,
                                            transition: 'background-color 0.3s, opacity 0.3s',
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-light"
                                            aria-label="Descartar"
                                            onClick={(e) => handleDescartar(e, item)}
                                            style={{
                                                position: 'absolute',
                                                top: '8px',
                                                right: '8px',
                                                lineHeight: '1',
                                                padding: '0.1rem 0.4rem',
                                                fontSize: '0.95rem',
                                            }}
                                        >
                                            ×
                                        </button>
                                        <div className="d-flex align-items-center gap-2 mb-1">
                                            <i
                                                className={`bi ${meta.icon}`}
                                                style={{ color: meta.color, fontSize: '0.9rem', flexShrink: 0 }}
                                                title={meta.label}
                                            />
                                            <span
                                                className={leido ? '' : 'fw-semibold'}
                                                style={{ fontSize: '0.92rem', lineHeight: 1.4 }}
                                            >
                                                {item.mensaje}
                                            </span>
                                        </div>
                                        <small className="text-muted" style={{ fontSize: '0.9rem' }}>
                                            📅 {new Date(item.fechaProgramada).toLocaleDateString('es-AR')} · 🕒{' '}
                                            {new Date(item.fechaProgramada).toLocaleTimeString('es-AR', {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                            })}
                                        </small>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MailCampana;
